<template>
  <v-dialog v-model="visible" max-width="1200px" scrollable persistent>
    <v-card>
      <v-card-title class="text-uppercase">Establecer Estado</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="detalle in detallesTransaccion" :key="detalle.id" cols="12" lg="6">
            <v-list-item dense three-line>
              <v-list-item-content>
                <v-list-item-title>
                  {{ detalle.clasificador }} - {{ detalle.debe }} ({{ detalle.cantidad }} x {{ detalle.costo }})
                </v-list-item-title>
                <v-list-item-subtitle>{{ detalle.unidad_gasto }} - {{ detalle.unidad }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ detalle.estado }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col cols="12">
            <v-select
              class="mt-2"
              :items="estados"
              label="Estado"
              v-model="form.estado"
              placeholder=" "
              outlined
              dense
              hide-details />

            <small v-for="error in errores.estado" :key="error" class="text-danger">{{ error }}</small>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="establecerEstado"> Establecer </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ESTADOS_DETALLE_TRANSACCION } from '../utils';
export default {
  name: 'ModalEstablecerEstado',
  data: () => ({
    visible: false,
    titulo: 'Establecer Estado',
    form: {
      estado: null,
    },
    errores: {
      estado: [],
    },
    detallesTransaccion: [],
    estados: Object.values(ESTADOS_DETALLE_TRANSACCION).map((estado) => ({
      text: estado,
      value: estado,
    })),
  }),
  watch: {
    'form.estado': function () {
      this.errores.estado = [];
    },
  },
  methods: {
    abrir(datos) {
      this.detallesTransaccion = datos;
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    establecerEstado() {
      if (!this.form.estado) {
        this.errores.estado = ['El estado es requerido'];

        return;
      }

      this.detallesTransaccion.forEach((item) => {
        item.estado = this.form.estado;
      });

      this.$emit('establecer-estado');

      this.form.estado = null;

      this.cerrar();
    },
  },
};
</script>

<style>
</style>